import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { ZegoExpressEngine } from 'zego-express-engine-webrtc';
import { addWebSuffix } from '../utils/string.util';
import { LoginService } from '../pages/login/services/login.service';

export interface RoomUser {
  userID: string;
  userName: string;
  imageUrl: string;
}

export interface RemoteUser {
  userID: string;
  userName: string;
  avatarUrl: string;
  isMicOn: boolean;
  isCamOn: boolean
  isSpeaking?: boolean;
  soundLevel?: number;
}

//Service tương tác với ZegoExpress ENGINE
@Injectable({ providedIn: 'root' })
export class ZegoEngineService {
  private zegoEngine?: ZegoExpressEngine;
  private engineDestroyed$ = new Subject<void>();
  private loginService = inject(LoginService);
  private loginTokenWeb = ''
  /** Observable for engine destruction notifications */
  get engineDestroyed() {
    return this.engineDestroyed$.asObservable();
  }

  // Nếu chưa có zegoEngine thì có phải init lại không?
  private ensureEngine(): ZegoExpressEngine | null {
    if (!this.zegoEngine) {
      console.warn('[Zego] Engine chưa được khởi tạo!');
      return null;
    }
    return this.zegoEngine;
  }

  /** Khởi tạo SDK */
  initEngine(appID: number, server: string): ZegoExpressEngine {
    if (this.zegoEngine) {
      console.info('[Zego] Engine đã được khởi tạo trước đó');
      return this.zegoEngine;
    }
    this.zegoEngine = new ZegoExpressEngine(appID, server, { scenario: 4 });
    this.zegoEngine.setLogConfig({ logLevel: "disable", remoteLogLevel: "disable", logURL: "" });
    this.zegoEngine.setDebugVerbose(false);
    this.zegoEngine.setSoundLevelDelegate(true, 100);
    console.info('[Zego] Engine initialized');
    return this.zegoEngine;
  }

  /** Huỷ SDK */
  destroyEngine(): void {
    const engine = this.ensureEngine();
    if (!engine) return;
    engine.destroyEngine();
    console.info('[Zego] Engine destroyed');
    this.zegoEngine = undefined;

    // Notify all services that engine is destroyed
    this.engineDestroyed$.next();
    this.engineDestroyed$.complete();
  }

  /** Lấy engine đã khởi tạo (an toàn) */
  get engine(): ZegoExpressEngine {
    const engine = this.ensureEngine();
    if (!engine) throw new Error('Zego engine chưa được khởi tạo!');
    return engine;
  }

  /**
   * Login to room with web suffix handling
   * @param roomID Room ID
   * @param userID User ID (will be suffixed with "_w" for web)
   * @param userName User name
   * @param token Optional token (will be generated if not provided)
   * @param shouldAddWebSuffix Whether to add "_w" suffix (default: true)
   * @param customEngine Optional custom engine to use instead of injected one
   * @returns Login success status
   */
  async loginRoom(
    roomID: string,
    userID: string,
    userName: string,
    type: "MEET" | "CALL" = "CALL"
  ): Promise<boolean> {
    try {
      const engine = this.ensureEngine();
      if (!engine) return false;


      // const loginToken;
      // Vẫn đang dùng token không có _W
      const finalUserID = type === "MEET" ? addWebSuffix(userID) : userID;
      const tokenZego = type === "MEET" ? sessionStorage.getItem("token_zego_w"): sessionStorage.getItem("token_zego");
      if(tokenZego) {
        const result = await engine.loginRoom(
          roomID,
          tokenZego,
          { userID: finalUserID, userName },
          { userUpdate: true }
        );
        return result
      }

      return false;

    } catch (error) {
      console.error('Login room error:', error);
      return false;
    }
  }

  /**
   * Logout from room
   * @param roomID Room ID
   */
  logoutRoom(roomID: string): void {
    const engine = this.ensureEngine();
    if (!engine) return;

    engine.logoutRoom(roomID);
  }


}
